import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ms-2 me-5 pt-3" }
const _hoisted_2 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_3 = { class: "col pt-2 text-start" }
const _hoisted_4 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_5 = {
  key: 2,
  class: "row"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center p-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", null, "The current filter selection does not return any data", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pulse_loader = _resolveComponent("pulse-loader")!
  const _component_ReportFilterView = _resolveComponent("ReportFilterView")!
  const _component_ReportChartView = _resolveComponent("ReportChartView")!
  const _component_ReportTableView = _resolveComponent("ReportTableView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.reportTemplate.filters.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_pulse_loader, {
                loading: _ctx.isLoading,
                color: "#1ebacb"
              }, null, 8, ["loading"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTemplate.filters, (filter) => {
              return (_openBlock(), _createBlock(_component_ReportFilterView, {
                key: filter.name,
                filter: filter,
                preselect: _ctx.filters.get(filter.name),
                onFilterChanged: _ctx.onFilterChanged
              }, null, 8, ["filter", "preselect", "onFilterChanged"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTemplate.charts, (chart) => {
              return (_openBlock(), _createElementBlock("div", {
                key: chart.title,
                class: "col-md col-sm-12",
                style: _normalizeStyle(_ctx.chartStyle(chart))
              }, [
                _createVNode(_component_ReportChartView, {
                  chart: chart,
                  data: _ctx.chartDataSet(chart)
                }, null, 8, ["chart", "data"])
              ], 4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTemplate.tables, (table) => {
              return (_openBlock(), _createElementBlock("div", {
                key: table.title,
                class: "col"
              }, [
                _createVNode(_component_ReportTableView, {
                  table: table,
                  data: _ctx.tableDataSet(table)
                }, null, 8, ["table", "data"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}